import React, { Component,ReactElement,useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import Link from "../../components/html/link";
import "./fachkraefte.css";
import KarriereImg from "./fachkraefteImg";
import { useTranslation } from "react-i18next";

type Props = {theme: ThemeProps,}
export default function Service({ theme }: Props) {
		const { t, i18n } = useTranslation();
    return (
		<PageLayout title="Home" theme={theme}>
      <div className="projects-main">
        <div className="basic-projects">
          <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <KarriereImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">{t("fachkraefte.title")}</h1>
                <p className="projects-header-detail-text subTitle">
                  {t("fachkraefte.desc")}
                </p>
                <div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
                <Link
                  text="Kontak aufnehmen"
                  href="/contact"
                  className="portfolio-repo-btn"
                />
              	</div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
			<div className="fachkraefte main">
						<div className="row justify-content-center">
							<h2 className="ourservices_h2" style={{textAlign: "center"}}>{t("fachkraefte.desc.list.title")}</h2>
						</div>
						
							<div className="row justify-content-center">
										<div className="col-lg-6 mb-5">
											<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
											<div className="textcard-item text-center h-100">
												<div className="textcard-icon">
													<span
														className="iconify"
														data-icon="mdi:account-hard-hat"
														style={{ color: "var(--primary)", fontSize: "45px" }}
														data-inline="false"
													></span>
												</div>
												<div className="textcard-headline ">
													<h3>{t("fachkraefte.desc.list.1")}</h3>
												</div>
												<div className="textcard-text">
													<p dangerouslySetInnerHTML={
														{__html: t('fachkraefte.desc.list.1.desc', {interpolation: {escapeValue: false}})}
													}/>
												</div>
											</div>
											</Fade>
										</div>
										
										<div className="col-lg-6 mb-5">
											<Fade direction="down" duration={1000} triggerOnce={true} className="h-100">
											<div className="textcard-item text-center h-100">
												<div className="textcard-icon">
													<span
														className="iconify"
														data-icon="mdi:monitor-account"
														style={{ color: "var(--primary)", fontSize: "45px" }}
														data-inline="false"
													></span>
												</div>
												<div className="textcard-headline ">
													<h3>{t("fachkraefte.desc.list.2")}</h3>
												</div>
												<div className="textcard-text">
													<p dangerouslySetInnerHTML={
																										{__html: t('fachkraefte.desc.list.2.desc', {interpolation: {escapeValue: false}})}
																									}/>
												</div>
											</div>
											</Fade>
										</div>

										<div className="col-lg-6 mb-5">
											<Fade direction="right" duration={1000} triggerOnce={true} className="h-100">
											<div className="textcard-item text-center h-100">
												<div className="textcard-icon">
													<span
														className="iconify"
														data-icon="mdi:doctor"
														style={{ color: "var(--primary)", fontSize: "45px" }}
														data-inline="false"
													></span>
												</div>
												<div className="textcard-headline ">
													<h3 style={{ wordWrap: "break-word" }}>{t("fachkraefte.desc.list.3")}</h3>
												</div>
												<div className="textcard-text">
													<p dangerouslySetInnerHTML={
																										{__html: t('fachkraefte.desc.list.3.desc', {interpolation: {escapeValue: false}})}
																									}/>
												</div>
											</div>
											</Fade>
										</div>
										
										<div className="col-lg-6 mb-5">
											<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
											<div className="textcard-item text-center h-100">
												<div className="textcard-icon">
													<span
														className="iconify"
														data-icon="mdi:mother-nurse"
														style={{ color: "var(--primary)", fontSize: "45px" }}
														data-inline="false"
													></span>
												</div>
												<div className="textcard-headline ">
													<h3>{t("fachkraefte.desc.list.4")}</h3>
												</div>
												<div className="textcard-text">
													<p dangerouslySetInnerHTML={
																										{__html: t('fachkraefte.desc.list.4.desc', {interpolation: {escapeValue: false}})}
																									}/>
												</div>
											</div>
											</Fade>
										</div>
										
							</div>        
			      
			      </div>
						
						
			<div className="main">
							<h1 className="projects-heading-text">{t('fachkraefte.future.title')}</h1>
							<div dangerouslySetInnerHTML={
							    {__html: t('fachkraefte.future.desc', {interpolation: {escapeValue: false}})}
							} />
							
											<div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
											                <Link
											                  text="Kontak aufnehmen"
											                  href="/contact"
											                  className="portfolio-repo-btn"
											                />
											              	</div>
																							
						</div>	
						
      </PageLayout>
    );
}